module.exports = __webpack_public_path__ + "img/expire-date.65cea5bc.svg";